import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import PanDulce from "../../images/pan-dulce-pack.jpeg";
import Cookies from "../../images/cookies-pack.jpeg";
import Panes from "../../images/pan-pack.jpeg";
import PanTradicional from "../../images/panTradicional.jpg";
import PanSalvado from "../../images/panSalvado.jpg";
import Pepas from "../../images/pepas-pack.jpeg";
import PepasBatata from "../../images/pepasBatata.jpg";
import PanDulceChoco from "../../images/panDulceChoco.jpeg";
import PanDeCampo from "../../images/PanDeCampo.jpeg";

const Container = tw.div`relative -mx-8 -mt-8`;
const Content = tw.div`mx-auto py-20 lg:py-24`;
const ThreeColumn = tw.div`flex flex-row flex-wrap justify-center items-stretch`;
const Column = tw.div`mt-8 md:mt-24 md:w-1/4 sm:w-1/3 w-1/2`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const StyledImage = styled.img`
    ${tw`w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110`}
`;
const MediaContainer = styled.button.attrs({
    className: "group"
})`
    ${tw`relative rounded-2xl aspect-[9/16] overflow-hidden bg-gray-200`}
`;

const Card = tw.div`mx-4 xl:mx-8 max-w-sm max-w-xs`;
const Category = tw.div`mt-4 text-secondary-100 font-bold text-xl`;

const Overlay = tw.div`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4`;
const Popup = tw.div`bg-white p-6 rounded-3xl max-w-lg w-full relative shadow-lg flex gap-4`;
const PopupDetails = tw.div`flex flex-col w-1/2`;
const PopupImage = tw.div`flex w-1/2`;
const CloseButton = tw.button`absolute top-0 right-0 text-2xl text-gray-500 hover:text-gray-800 mt-2 mr-2`;

const Image = styled.img`
    ${tw`rounded-xl mb-4`}
    width: 100%;
    max-height: 200px;
    object-fit: cover;
`;

const Label = tw.div`bg-yellow-400 text-white font-bold text-lg px-4 py-1 rounded-md mb-3`;
const Description = tw.div`text-gray-700 text-base`;
const Line = tw.p`mb-1 leading-relaxed`;

const VideoCard = ({ post, onClick }) => (
    <Card>
        <MediaContainer onClick={onClick}>
            <StyledImage src={post.videoSrc} />
        </MediaContainer>
        <Category>{post.category}</Category>
    </Card>
);

export default () => {
    const [selectedPost, setSelectedPost] = useState(null);

    const blogPosts = [
        {
            videoSrc: Panes,
            category: "Pan Rústico Multisemillas",
            info: ["Con harina integral.", "Peso: 550g.", "Caja: 12 unidades"]
        },
        {
            videoSrc: PanTradicional,
            category: "Pan Rústico Tradicional",
            info: ["Con harina integral.", "Peso: 550g.", "Caja: 12 unidades"]
        },
        {
            videoSrc: PanSalvado,
            category: "Pan Rústico Salvado y Avena",
            info: ["Con harina integral.", "Peso: 550g.", "Caja: 12 unidades"]
        },
        {
            videoSrc: Pepas,
            category: "Pepas de Membrillo",
            info: [
                "Integrales con semillas de chía.",
                "Peso: 260g y 1kg.",
                "Caja: 10 unidades x kg",
                "Caja: 40 unidades x 260g"
            ]
        },

        {
            videoSrc: PepasBatata,
            category: "Pepas de Batata",
            info: [
                "Integrales con semillas de chía.",
                "Peso: 260g y 1kg.",
                "Caja: 10 unidades x kg",
                "Caja: 40 unidades x 260g"
            ]
        },
        {
            videoSrc: Cookies,
            category: "Choco Chips",
            info: [
                "Integrales con avena y chips de chocolate.",
                "Peso: 260g y 1kg.",
                "Caja: 10 unidades x kg",
                "Caja: 40 unidades x 260g"
            ]
        },
        {
            videoSrc: PanDulce,
            category: "Pan dulce con frutas",
            info: ["Peso: 400g.", "Caja: 8 unidades"]
        },
        {
            videoSrc: PanDulceChoco,
            category: "Pan dulce con chips de chocolate",
            info: ["Peso: 360g.", "Caja: 8 unidades"]
        },
        {
            videoSrc: PanDeCampo,
            category: "Pan de campo con semillas",
            info: ["Con masa madre", "Peso: 650g.", "Caja: 10 unidades"]
        }
    ];

    return (
        <Container id="productos">
            <Content>
                <HeadingInfoContainer>
                    <HeadingTitle>Productos</HeadingTitle>
                    <HeadingDescription>Descubrí nuestras especialidades</HeadingDescription>
                </HeadingInfoContainer>
                <ThreeColumn>
                    {blogPosts.map((post, index) => (
                        <Column key={index}>
                            <VideoCard post={post} onClick={() => setSelectedPost(post)} />
                        </Column>
                    ))}
                </ThreeColumn>

                {selectedPost && (
                    <Overlay onClick={() => setSelectedPost(null)}>
                        <Popup onClick={(e) => e.stopPropagation()}>
                            <CloseButton onClick={() => setSelectedPost(null)}>×</CloseButton>
                            <PopupImage>
                                <Image src={selectedPost.videoSrc} alt={selectedPost.category} />
                            </PopupImage>
                            <PopupDetails>
                                <Label>{selectedPost.category.toUpperCase()}</Label>
                                <Description>
                                    {selectedPost.info?.map((line, i) => (
                                        <Line key={i}>{line}</Line>
                                    ))}
                                </Description>
                            </PopupDetails>
                        </Popup>
                    </Overlay>
                )}
            </Content>
        </Container>
    );
};
